(function(){
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    const applyLabel = () => {
      const btn = form.querySelector('button[name="add"], [data-add-to-cart]');
      if (!btn) return;
      const txtEl = btn.querySelector('span') || btn;
      txtEl.textContent = btn.disabled || btn.classList.contains('disabled') ? 'Sold Out' : 'Pre-Order';
      btn.disabled = false;
      btn.classList.remove('disabled');
    };

    // Override theme’s internal callback, if it exists
    if (window.theme && typeof window.theme.updateAddToCartButton === 'function') {
      const orig = window.theme.updateAddToCartButton;
      window.theme.updateAddToCartButton = function(...args) {
        orig.apply(this, args);
        applyLabel();
      };
    }

    // Fallback: listen for common variant events
    ['variant:change', 'variant:changed', 'theme:variant-change', 'product:variant-change'].forEach(evt =>
      document.addEventListener(evt, () => setTimeout(applyLabel, 50))
    );

    // Monitor direct select/input changes
    form.addEventListener('change', (e) => {
      if (e.target.matches('select, input')) setTimeout(applyLabel, 50);
    });

    applyLabel(); // initial enforce
  });
})();
